import { useState } from 'react';
import { PushNotification, tailwindOverride } from '@getsynapse/design-system';
import useNotifications from 'Hooks/useNotifications';
import NotificationLink from 'Molecules/NotificationLink/NotificationLink';

const Notifications = () => {
  const { list, setList } = useNotifications();
  const [hiddenIndices, setHiddenIndices] = useState<string[]>([]);

  const handleRemove = (index: string) => {
    setHiddenIndices((prevState) => prevState.concat(index));
    setList((prevState) =>
      prevState.filter((notification) => notification.id !== index)
    );
  };

  return (
    <div className='top-14 fixed right-0 z-50'>
      {list.map((item) => {
        return (
          <NotificationLink
            to={item.link}
            key={item.id}
            onClick={() => handleRemove(item.id)}
            hidden={hiddenIndices.includes(item.id)}
          >
            <PushNotification
              timeout={4000}
              onTimeout={() => handleRemove(item.id)}
              className={tailwindOverride(
                'mb-2 relative animate-pushNotify leading-4',
                'text-neutral-black'
              )}
              displayCloseButton
              closeCallback={() => handleRemove(item.id)}
            >
              {item.content}
            </PushNotification>
          </NotificationLink>
        );
      })}
    </div>
  );
};

export default Notifications;
